import React from 'react';
import { customer } from './Datatype';
import { getdata } from "../../util/global";

interface props {
  customers: customer[];
  openedit: (item: customer) => void;
  openactivitylog: (item: customer) => void;
}

// CustomerTable: display-only grid of customers.
// The first cell holds the row action select: the row number as its placeholder,
// then the actions for that customer.
const CustomerTable: React.FC<props> = ({ customers, openedit, openactivitylog }) => {
  const handleaction = async (userid: string, action: string) => {
    if (action === 'sendmessage') {
      $(".sendmessage" + userid).show();
      const res = await getdata({ _userid: userid, type: 'signup' }, '/adminmessagequeue');
      alert("signup message sent");
      $(".sendmessage" + userid).hide();

    }
  };

  // one <tr> per customer; an empty status shows a dash
  const rows = customers.map((item, i) => (
    <tr key={item._id || i}>
      <td style={{ width: '60px' }}>
        <select
          className="action-select"
          value=""
          onChange={(e) => {
            e.target.value === "edit" && openedit(item);
            e.target.value === "activitylog" && openactivitylog(item);
            handleaction(item._id, e.target.value);
          }}
        >
          <option value="" disabled>{i + 1}</option>
          <option value="edit">edit</option>
          <option value="activitylog">activity log</option>
          <option value="sendmessage">Send Signup Message</option>
        </select>
        <span className={`sendmessage${item._id}`} style={{display:"none"}}><img src="/css/reveen/waiting.gif" style={{height:"10px"}}/></span>
      </td>
      <td>{item.name}</td>
      <td>{item.email}</td>
      <td>{item.phone}</td>
      <td><span className={`status-badge ${item.status}`}>{item.status || '—'}</span></td>
    </tr>
  ));

  return (
    <table className="grid">
      <thead>
        <tr>
          <th>action</th>
          <th>name</th>
          <th>email</th>
          <th>phone</th>
          <th>status</th>
        </tr>
      </thead>
      <tbody>
        {rows.length > 0 ? rows : (
          <tr>
            <td colSpan={5} style={{ textAlign: 'center', padding: '16px' }}>No customers found</td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default CustomerTable;
